<template>
  <div class="merchant">
    <van-form>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商家名称</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_name.focus()"
            ref="merchant_name"
            required
            v-model="gather.merchant_name"
            input-align="right"
            placeholder="城市/区/路+店铺名+行业"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商户简称</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_alias.focus()"
            ref="merchant_alias"
            required
            v-model="gather.merchant_alias"
            input-align="right"
            placeholder="请输入简称"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商户注册名称</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_company.focus()"
            required
            ref="merchant_company"
            v-model="gather.merchant_company"
            input-align="right"
            placeholder="个体户+法人名称"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>地区</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            readonly
            clickable
            name="area"
            :value="merchant_province"
            placeholder="请选择省市县"
            @click="shArea = true"
          />
          <van-popup v-model="shArea" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirmc"
              @cancel="shArea = false"
              @change="onChange"
            />
          </van-popup>
        </div>
      </div>

      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>详细地址</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_address.focus()"
            ref="merchant_address"
            required
            v-model="gather.merchant_address"
            input-align="right"
            placeholder="请输入详细地址"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商户联系姓名</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_person.focus()"
            ref="merchant_person"
            required
            v-model="gather.merchant_person"
            input-align="right"
            placeholder="请输入姓名"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商户联系人电话</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_phone.focus()"
            ref="merchant_phone"
            required
            v-model="gather.merchant_phone"
            input-align="right"
            placeholder="请输入电话"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>商户联系人邮箱</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            @click="$refs.merchant_email.focus()"
            ref="merchant_email"
            v-model="gather.merchant_email"
            input-align="right"
            placeholder="请输邮箱"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>客户服务电话</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            @click="$refs.merchant_service_phone.focus()"
            ref="merchant_service_phone"
            required
            v-model="gather.merchant_service_phone"
            input-align="right"
            placeholder="请输入客服电话"
          />
        </div>
      </div>
      <!-- <p class="home-perspmal-boundary"></p> -->
      <!-- <div style=" background-color: #fff;" class="home-cell__value-buttom">
        <Debounce :time="1000" isDebounce>
          <van-button @click="nextstep" round type="primary">下一步</van-button>
        </Debounce>
      </div>-->
      <div class="home">
        <!-- <van-form> -->
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>客户服务主体类型</span>
          </div>
          <div class="home-perspmal-van-cell__value home-perspmal-van-cell__values">
            <van-radio-group v-model="gather.merchant_business_type" direction="horizontal">
              <van-radio name="1">企业</van-radio>
              <van-radio name="2" style="margin:0;">个体商户</van-radio>
              <van-radio name="3" style="margin:0;">小微商户</van-radio>
            </van-radio-group>
          </div>
        </div>
        <p class="home-perspmal-boundary"></p>
        <div class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>行业类目</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-field
              readonly
              clickable
              name="area"
              :value="business_name"
              placeholder="请选择行业类目"
              @click="shAres = true"
            />
            <van-popup v-model="shAres" position="bottom">
              <van-picker
                show-toolbar
                :columns="columna"
                @confirm="onConfirmw"
                @cancel="shAres = false"
                @change="onChangs"
              />
            </van-popup>
          </div>
          <!-- <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
            <span class="home-van-dar-time" @click="showsesq = true">{{gather.business_name}}</span>
            <van-calendar
              v-model="showsesq"
              @confirm="onConfirmasa"
              color="#0065F0"
              :min-date="minDate"
              :max-date="maxDate"
            />
          </div>-->
        </div>
        <p v-if="conglomerate" class="home-perspmal-boundary"></p>
        <div v-if="conglomerate" class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>财户类型</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-radio-group v-model="fylist.account_type" direction="horizontal">
              <van-radio v-if="gather.merchant_business_type!=3" name="1">对公</van-radio>
              <van-radio name="2">对私</van-radio>
            </van-radio-group>
          </div>
        </div>
        <p v-if="conglomerate" class="home-perspmal-boundary"></p>
        <div v-if="conglomerate" class="home-perspmal-van-cell">
          <div class="home-perspmal-van-cell__title">
            <span>结算类型</span>
          </div>
          <div class="home-perspmal-van-cell__value">
            <van-radio-group v-model="fylist.settlement_type" direction="horizontal">
              <van-radio name="1">法人结算</van-radio>
              <van-radio name="2" v-if="fylist.account_type!=1">非法人结算</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div v-if="conglomerate">
          <!-- asdasdasdsa -->
          <div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>营业证件类型</span>
              </div>
              <div class="home-perspmal-van-cell__value home-perspmal-van-cell__values">
                <van-radio-group v-model="fylist.license_type" direction="horizontal">
                  <van-radio name="0">营业执照</van-radio>
                  <van-radio name="1" style="margin:0;">三证合一</van-radio>
                  <van-radio name="2" style="margin:0;">手持身份证</van-radio>
                </van-radio-group>
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>营业证件号码</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.license_no.focus()"
                  ref="license_no"
                  required
                  v-model="fylist.license_no"
                  input-align="right"
                  placeholder="请输入证件号码"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>营业证件到期日</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <span class="home-van-dar-time" @click="show = true">{{fylist.license_expire}}</span>
                <van-calendar
                  v-model="show"
                  @confirm="onConfirm"
                  color="#0065F0"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </div>
            </div>
            <p v-if="fylist.settlement_type!=1" class="home-perspmal-boundary"></p>
            <div v-if="fylist.settlement_type!=1" class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>法人姓名</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.artif_nm.focus()"
                  ref="artif_nm"
                  required
                  v-model="fylist.artif_nm"
                  input-align="right"
                  placeholder="请输入法人姓名"
                />
              </div>
            </div>
            <p v-if="fylist.settlement_type!=1" class="home-perspmal-boundary"></p>
            <div v-if="fylist.settlement_type!=1" class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>法人身份证</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.legalIdnum.focus()"
                  ref="legalIdnum"
                  required
                  v-model="fylist.legalIdnum"
                  input-align="right"
                  placeholder="请输入法人身份证"
                />
              </div>
            </div>
            <p v-if="fylist.settlement_type!=1" class="home-perspmal-boundary"></p>
            <div v-if="fylist.settlement_type!=1" class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>身份证有效期</span>
              </div>
              <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
                <span class="home-van-dar-time" @click="showse = true">{{fylist.legalIdnumExpire}}</span>
                <van-calendar
                  v-model="showse"
                  @confirm="onConfirma"
                  color="#0065F0"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>结算人身份证号码</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.merchant_id_no.focus()"
                  ref="merchant_id_no"
                  required
                  v-model="fylist.merchant_id_no"
                  input-align="right"
                  placeholder="请输入证件号码"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>结算人身份证有效期</span>
              </div>
              <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
                <span
                  class="home-van-dar-time"
                  @click="showses = true"
                >{{fylist.merchant_id_expire}}</span>
                <van-calendar
                  v-model="showses"
                  @confirm="onConfirmas"
                  color="#0065F0"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>入账银行开户名</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  ref="account_name"
                  @click="$refs.account_name.focus()"
                  required
                  v-model="fylist.account_name"
                  input-align="right"
                  placeholder="入账银行开户名"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>入账银行开户卡号</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.account_no.focus()"
                  ref="account_no"
                  required
                  v-model="fylist.account_no"
                  input-align="right"
                  placeholder="输入入账银行开户卡号"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>入账银行预留手机号</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-field
                  @click="$refs.account_phone.focus()"
                  ref="account_phone"
                  required
                  v-model="fylist.account_phone"
                  input-align="right"
                  placeholder="输入入账银行预留手机号"
                />
              </div>
            </div>
            <p class="home-perspmal-boundary"></p>
            <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>入账银行卡开户支行</span>
              </div>
              <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
                <van-field
                  readonly
                  clickable
                  name="area"
                  :value="fylist.bank_name"
                  placeholder="请选择银行卡开户支行"
                  @click="shArel = true"
                />
                <van-popup
                  v-model="shArel"
                  position="right"
                  :style="{ height: '100%'}"
                  class="search-rights"
                >
                  <van-search
                    v-model="search"
                    show-action
                    @click="$refs.search.focus()"
                    ref="search"
                    placeholder="请输入搜索关键词"
                    @search="onSearch"
                  >
                    <template #action>
                      <div @click="onSearch">搜索</div>
                    </template>
                  </van-search>
                  <van-cell v-for="item in searchlist" :key="item.back_id">
                    <template>
                      <div
                        @click="back_branch(item)"
                        class="back_branch_number"
                        :id="item.back_branch_number"
                      >{{item.back_branch_name}}</div>
                    </template>
                  </van-cell>
                </van-popup>
              </div>
            </div>
            <!-- <p class="home-perspmal-boundary"></p> -->
            <!-- <div class="home-perspmal-van-cell">
              <div class="home-perspmal-van-cell__title">
                <span>清算类型</span>
              </div>
              <div class="home-perspmal-van-cell__value">
                <van-radio-group v-model="fylist.settle_type" direction="horizontal">
                  <van-radio name="1">自动结算</van-radio>
                  <van-radio name="2">手动结算</van-radio>
                </van-radio-group>
              </div>
            </div>-->
          </div>
          <!-- asdasdasdsa -->
          <div>
            <p class="home-perspmal-boundary"></p>
            <uploadImg ref="business" class="uploader-business" label="营业执照" @business="business"></uploadImg>
            <p class="home-perspmal-boundary"></p>
            <van-field class="uploader-identity" name="uploader" identity label="法人身份证正反面">
              <template #input>
                <upload ref="identityZ" @identityZ="identityZ"></upload>
                <upload ref="identityY" @identityY="identityY"></upload>
              </template>
            </van-field>
            <p v-if="privateAnd" class="home-perspmal-boundary"></p>
            <van-field
              v-if="privateAnd"
              class="uploader-bankCard"
              name="uploader"
              identity
              label="入账银行卡正反面照片"
            >
              <template #input>
                <upload ref="img_bankcard_a" @img_bankcard_a="img_bankcard_a"></upload>
                <upload ref="img_bankcard_b" @img_bankcard_b="img_bankcard_b"></upload>
              </template>
            </van-field>
            <p v-if="privateAnd" class="home-perspmal-boundary"></p>
            <van-field
              v-if="privateAnd"
              class="uploader-identity"
              name="uploader"
              identity
              label="对私账户身份证正反面照片"
            >
              <template #input>
                <upload ref="img_private_idcard_a" @img_private_idcard_a="img_private_idcard_a"></upload>
                <upload ref="img_private_idcard_b" @img_private_idcard_b="img_private_idcard_b"></upload>
              </template>
            </van-field>
            <p v-if="persons" class="home-perspmal-boundary"></p>
            <uploader
              v-if="persons"
              ref="img_unincorporated"
              class="home-pmal-Photo"
              label="入账非法人证明照片"
              @img_unincorporated="img_unincorporated"
            ></uploader>
            <p class="home-perspmal-boundary"></p>
            <uploader ref="img_logo" class="home-pmal-Photo" label="商户门头照片" @img_logo="img_logo"></uploader>
            <p class="home-perspmal-boundary"></p>
            <uploader
              ref="img_indoor"
              class="home-pmal-Photo"
              label="门脸(内设)照片(前台)"
              @img_indoor="img_indoor"
            ></uploader>
            <p class="home-perspmal-boundary"></p>
            <!-- <uploader
              ref="img_contract"
              class="home-pmal-Photo"
              label="店内环境照片"
              @img_contract="img_contract"
            ></uploader>-->
            <p class="home-perspmal-boundary"></p>
            <uploader ref="img_other" class="home-pmal-Photo" label="其他证明材料" @img_other="img_other"></uploader>
            <p class="home-perspmal-boundary"></p>
            <uploader
              ref="img_open_permits"
              class="home-pmal-Photo"
              label="开户许可证照片"
              @img_open_permits="img_open_permits"
            ></uploader>
            <p class="home-perspmal-boundary"></p>
            <uploader
              ref="img_org_code"
              class="home-pmal-Photo"
              label="组织机构代码证照片"
              @img_org_code="img_org_code"
            ></uploader>
            <p class="home-perspmal-boundary"></p>
            <uploader
              ref="img_tax_reg"
              class="home-pmal-Photo"
              label="税务登记证照片"
              @img_tax_reg="img_tax_reg"
            ></uploader>

            <!-- <p class="home-perspmal-boundary"></p>
            <uploader
              ref="img_sub_account_promiss"
              class="home-pmal-Photo"
              label="分账承诺函"
              @img_sub_account_promiss="img_sub_account_promiss"
            ></uploader>-->
          </div>
        </div>
        <div v-if="!conglomerate">
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>财户类型</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-radio-group v-model="fylist.account_type" direction="horizontal">
                <van-radio name="2">对私</van-radio>
              </van-radio-group>
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>结算类型</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-radio-group v-model="fylist.settlement_type" direction="horizontal">
                <van-radio name="1">法人结算</van-radio>
              </van-radio-group>
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>营业证件类型</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-radio-group v-model="fylist.license_type" direction="horizontal">
                <van-radio name="2" style="margin:0;">手持身份证</van-radio>
              </van-radio-group>
            </div>
          </div>

          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>结算人身份证号码</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-field
                @click="$refs.merchant_id_no.focus()"
                ref="merchant_id_no"
                required
                v-model="fylist.merchant_id_no"
                input-align="right"
                placeholder="请输入证件号码"
              />
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>结算人身份证有效期</span>
            </div>
            <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
              <span class="home-van-dar-time" @click="showses = true">{{fylist.merchant_id_expire}}</span>
              <van-calendar
                v-model="showses"
                @confirm="onConfirmas"
                color="#0065F0"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>入账银行开户名</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-field
                @click="$refs.merchant_id_no.focus()"
                ref="merchant_id_no"
                required
                v-model="fylist.account_name"
                input-align="right"
                placeholder="入账银行开户名"
              />
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>入账银行开户卡号</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-field
                @click="$refs.account_no.focus()"
                ref="account_no"
                required
                v-model="fylist.account_no"
                input-align="right"
                placeholder="输入入账银行开户卡号"
              />
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>入账银行预留手机号</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-field
                @click="$refs.account_phone.focus()"
                ref="account_phone"
                required
                v-model="fylist.account_phone"
                input-align="right"
                placeholder="输入入账银行预留手机号"
              />
            </div>
          </div>
          <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>入账银行卡开户支行</span>
            </div>
            <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
              <van-field
                readonly
                clickable
                name="area"
                :value="fylist.bank_name"
                placeholder="请选择银行卡"
                @click="shArel = true"
              />
              <van-popup
                v-model="shArel"
                position="right"
                :style="{ height: '100%'}"
                class="search-rights"
              >
                <van-search v-model="search" show-action placeholder="请输入搜索关键词" @search="onSearch">
                  <template #action>
                    <div @click="onSearch">搜索</div>
                  </template>
                </van-search>
                <van-cell v-for="item in searchlist" :key="item.back_id">
                  <template>
                    <div
                      @click="back_branch(item)"
                      class="back_branch_number"
                      :id="item.back_branch_number"
                    >{{item.back_branch_name}}</div>
                  </template>
                </van-cell>
              </van-popup>
            </div>
          </div>
          <!-- <p class="home-perspmal-boundary"></p>
          <div class="home-perspmal-van-cell">
            <div class="home-perspmal-van-cell__title">
              <span>清算类型</span>
            </div>
            <div class="home-perspmal-van-cell__value">
              <van-radio-group v-model="fylist.settle_type" direction="horizontal">
                <van-radio name="1">自动结算</van-radio>
                <van-radio name="2">手动结算</van-radio>
              </van-radio-group>
            </div>
          </div>-->
          <p class="home-perspmal-boundary"></p>
          <uploader ref="img_logo" class="home-pmal-Photo" label="商户门头照片" @img_logo="img_logo"></uploader>
          <p class="home-perspmal-boundary"></p>
          <uploader
            ref="img_indoor"
            class="home-pmal-Photo"
            label="门脸(内设)照片(前台)"
            @img_indoor="img_indoor"
          ></uploader>
          <!-- <p class="home-perspmal-boundary"></p> -->
          <!-- <uploader
              ref="img_contract"
              class="home-pmal-Photo"
              label="店内环境照片"
              @img_contract="img_contract"
          ></uploader>-->
          <p class="home-perspmal-boundary"></p>
          <uploader ref="img_other" class="home-pmal-Photo" label="其他证明材料" @img_other="img_other"></uploader>
          <p class="home-perspmal-boundary"></p>
          <uploader
            ref="img_idcard_holding"
            class="home-pmal-Photo"
            label="本人手持身份证照片"
            @img_idcard_holding="img_idcard_holding"
          ></uploader>
          <!-- <p class="home-perspmal-boundary"></p>
          <uploader
            ref="img_sub_account_promiss"
            class="home-pmal-Photo"
            label="分账承诺函"
            @img_sub_account_promiss="img_sub_account_promiss"
          ></uploader>-->
          <p class="home-perspmal-boundary"></p>
          <van-field class="uploader-bankCard" name="uploader" identity label="入账银行卡正反面照片">
            <template #input>
              <upload ref="img_bankcard_a" @img_bankcard_a="img_bankcard_a"></upload>
              <upload ref="img_bankcard_b" @img_bankcard_b="img_bankcard_b"></upload>
            </template>
          </van-field>
          <p class="home-perspmal-boundary"></p>
          <van-field class="uploader-identity" name="uploader" identity label="对私账户身份证正反面照片">
            <template #input>
              <upload ref="img_private_idcard_a" @img_private_idcard_a="img_private_idcard_a"></upload>
              <upload ref="img_private_idcard_b" @img_private_idcard_b="img_private_idcard_b"></upload>
            </template>
          </van-field>
        </div>
        <!-- </van-form> -->

        <div class="home-cell__value-buttom">
          <Debounce :time="300" isDebounce>
            <van-button @click.stop="nextstep" round type="primary">提交</van-button>
          </Debounce>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import areaList from "@/config/area";
import { Toast } from "vant";

// import {
//   fupayAreaLists,
//   industry,
//   fybankBranchLists,
//   save
// } from "../../api/merchant/merchant";
import { getUserToken } from "@/utils/Cookie";
import { request } from "@/utils/https";
import uploadImg from "../../components/uploadImg";
import upload from "../../components/upload";
import uploader from "../../components/uploader";
// import store from "@/store/index";
// import axios from "axios";
export default {
  name: "merchant",
  components: {
    uploadImg,
    upload,
    uploader
  },
  data() {
    return {
      searchlist: [],
      search: "",
      cityDates: "", //安联当前选中市的所有区所有数据
      cityDater: "", //当前选中行业的所有区所有数据
      areaList,
      shArea: false,
      shAres: false,
      shArel: false,
      data: "",
      datx: "",
      columns: [
        {
          values: "",
          text: "column1",
          code: 1
        },
        {
          values: "",
          text: "column2",
          code: 0
        },
        {
          values: "",
          text: "column3",
          code: 0
        }
      ],
      columna: [
        {
          values: "",
          text: "column1",
          code: 1
        },
        {
          values: "",
          text: "column2",
          code: 0
        },
        {
          values: "",
          text: "column3",
          code: 0
        }
      ],
      columnl: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
      // gather: {
      //   merchant_name: "", //商家名称
      //   merchant_alias: "", //商家简称
      //   merchant_company: "", //商家注册名称
      //   merchant_province: "", //选择地址
      //   merchant_address: "", //详细地址
      //   merchant_person: "", //姓名
      //   merchant_phone: "", //客户电话
      //   merchant_email: "", //客户邮箱
      //   merchant_service_phone: "" //客户服务电话
      // },
      show: false,
      showse: false,
      showses: false,
      // showsesr: false,
      // showsesq: false,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(2038, 11, 31),
      shows: false,
      // showArea: false,
      merchant_province: "", //选择地址
      business_name: "", //行业类目名称
      // bank_name: "", //入账银行卡开户支行
      gather: {
        examine: "2", //提交资料: 1：第三方； 2：平台；
        merchant_name: "", //商家名称
        merchant_alias: "", //商家简称
        merchant_company: "", //商家注册名称
        merchant_province: "", //省级
        merchant_province_code: "", //省级编号
        merchant_city: "", //市级
        merchant_city_code: "", //市级编号
        merchant_county: "", //所在区
        merchant_county_code: "", //所在区编号
        merchant_address: "", //详细地址
        merchant_person: "", //姓名
        merchant_phone: "", //客户电话
        merchant_email: "", //客户邮箱
        merchant_service_phone: "", //客户服务电话
        // ///////////////////////////////////////////////////////
        merchant_business_type: "1", //客户服务主体类型
        business_name: "", //行业类目名称
        business_code: "" //行业类目编码
        // img_sub_account_promiss: "" //分账承诺函
      },
      fylist: {
        account_type: "1", //财户类型
        settlement_type: "1", //结算类型
        license_type: "0", //营业证件类型
        license_no: "", //营业证件号码
        license_expire: "", //营业证件到期日GoodsHouseholdType
        artif_nm: "", //法人姓名
        legalIdnum: "", //法人身份证
        legalIdnumExpire: "", //法人身份证到期
        merchant_id_no: "", //结算人身份证号码
        merchant_id_expire: "", //结算人身份证到期
        account_name: "", //	入账银行开户号
        account_no: "", //入账银行开户卡号
        account_phone: "", //入账银行预留手机号
        bank_name: "", //入账银行卡开户支行
        bank_no: "", //入账银行卡开户支行联行号
        settle_type: "1", //清算类型 1：自动结算，2：手动结算
        img_license: "", //营业执照
        img_idcard_a: "", //法人身份证正面
        img_idcard_b: "", //法人身份证反面
        img_private_idcard_a: "", //对私账户身份证正面照片
        img_private_idcard_b: "", //对私账户身份证反面照片
        img_bankcard_a: "", //入账银行卡正面照片
        img_bankcard_b: "", //入账银行卡反面照片
        img_logo: "", //商户门头照片
        img_indoor: "", //门脸(内设)照片(前台)
        img_contract: "", //店内环境照片
        img_other: "", //其他证明材料
        img_idcard_holding: "", //本人手持身份证照片
        img_open_permits: "", //开户许可证照片
        img_org_code: "", //组织机构代码证照片
        img_tax_reg: "", //税务登记证照片
        img_unincorporated: "" //入账非法人证明照片
      },
      fylist2: {
        account_type: "1", //财户类型
        settlement_type: "1", //结算类型
        license_type: "0", //营业证件类型
        license_no: "", //营业证件号码
        license_expire: "", //营业证件到期日GoodsHouseholdType
        artif_nm: "", //法人姓名
        legalIdnum: "", //法人身份证
        legalIdnumExpire: "", //法人身份证到期
        merchant_id_no: "", //结算人身份证号码
        merchant_id_expire: "", //结算人身份证到期
        account_name: "", //	入账银行开户号
        account_no: "", //入账银行开户卡号
        account_phone: "", //入账银行预留手机号
        bank_name: "", //入账银行卡开户支行
        bank_no: "", //入账银行卡开户支行联行号
        settle_type: "1", //清算类型 1：自动结算，2：手动结算
        img_license: "", //营业执照
        img_idcard_a: "", //法人身份证正面
        img_idcard_b: "", //法人身份证反面
        img_private_idcard_a: "", //对私账户身份证正面照片
        img_private_idcard_b: "", //对私账户身份证反面照片
        img_bankcard_a: "", //入账银行卡正面照片
        img_bankcard_b: "", //入账银行卡反面照片
        img_logo: "", //商户门头照片
        img_indoor: "", //门脸(内设)照片(前台)
        img_contract: "", //店内环境照片
        img_other: "", //其他证明材料
        img_idcard_holding: "", //本人手持身份证照片
        img_open_permits: "", //开户许可证照片
        img_org_code: "", //组织机构代码证照片
        img_tax_reg: "", //税务登记证照片
        img_unincorporated: "" //入账非法人证明照片
      },
      conglomerate: true, //用于服务主体类型切换是的页面渲染判断
      privateAnd: false,
      persons: false
    };
  },
  watch: {
    //利用watch数据实时监听进行判断
    "gather.merchant_business_type": {
      deep: true,
      handler: function(val) {
        (this.conglomerate = true),
          (this.privateAnd = false),
          (this.persons = false);
        this.fylist = this.fylist2; //用户进行服务主体类型切换时清空当前对象中的数据
        // 判断是否用到了这个节点触发子组件中的方法
        if (this.$refs.img_logo) this.$refs.img_logo.deleter();
        if (this.$refs.img_indoor) this.$refs.img_indoor.deleter();
        if (this.$refs.img_contract) this.$refs.img_contract.deleter();
        if (this.$refs.img_other) this.$refs.img_other.deleter();
        if (this.$refs.img_open_permits) this.$refs.img_open_permits.deleter();
        if (this.$refs.img_org_code) this.$refs.img_org_code.deleter();
        if (this.$refs.img_tax_reg) this.$refs.img_tax_reg.deleter();
        if (this.$refs.img_idcard_holding)
          this.$refs.img_idcard_holding.deleter();
        if (this.$refs.img_unincorporated)
          this.$refs.img_unincorporated.deleter();
        if (this.$refs.business) this.$refs.business.deleter();
        if (this.$refs.identityY) this.$refs.identityY.deleter();
        if (this.$refs.identityZ) this.$refs.identityZ.deleter();
        if (this.$refs.img_bankcard_a) this.$refs.img_bankcard_a.deleter();
        if (this.$refs.img_bankcard_b) this.$refs.img_bankcard_b.deleter();
        if (this.$refs.img_sub_account_promiss)
          this.$refs.img_sub_account_promiss.deleter();
        if (this.$refs.img_private_idcard_a)
          this.$refs.img_private_idcard_a.deleter();
        if (this.$refs.img_private_idcard_b)
          this.$refs.img_private_idcard_b.deleter();
        // 判断当前选择的商户类型
        if (this.conglomerate == false) {
          this.fylist.license_type = "2";
          this.fylist.account_type = "2";
        } else if (this.conglomerate == true) {
          this.fylist.license_type = "0";
          this.fylist.account_type = "1";
        }
        if (val == 1 || val == 2) {
          if (this.fylist.account_type == 1) {
            this.conglomerate = true;
          }
        } else if (val == 3) {
          this.conglomerate = false;
          this.fylist.license_type = "2";
          this.fylist.account_type = "2";
        }
      }
    },
    "fylist.account_type": {
      deep: true,
      handler: function(val) {
      //  console.log(val,"---------------------------------------")
        this.fylist.settlement_type = "1";
        if (val == 1) {
          this.privateAnd = false;
        } else if (val == 2) {
          this.privateAnd = true;
        }
      }
    },
    "fylist.settlement_type": {
      deep: true,
      handler: function(val) {
        if (val == 1) {
          this.persons = false;
          this.fylist.artif_nm = "";
          this.fylist.legalIdnum = "";
          this.fylist.legalIdnumExpire = "";
          this.fylist.img_unincorporated = "";
          if (this.$refs.img_unincorporated)
            this.$refs.img_unincorporated.deleter();
        } else if (val == 2) {
          this.persons = true;
        }
      }
    }
  },
  methods: {
    back_branch(e) {
      this.shArel = false;
      //入账银行卡开户支行
      this.fylist.bank_name = e.back_branch_name;
      this.fylist.bank_no = e.back_branch_number;
    },
    onSearch() {
      this.fybankBranchListse();
    },
    // vant picker选择器回调
    onChange(picker, values) {
      picker.setColumnValues(1, this.cityDate(this.data, values[0].text));
      picker.setColumnValues(2, this.county(this.data, values[1].text));
    },
    // 修改市
    cityDate(data, province) {
      var that = this;
      data.forEach(function(res) {
        if (res.label == province) {
          that.cityDates = res;
        }
      });
      return that.cityDates.children.map(function(res) {
        return { text: res.label, code: res.code };
      });
    },
    county(data, county) {
      var that = this;
      var countyDate = "";
      that.cityDates.children.forEach(function(res) {
        if (res.label == county) {
          countyDate = res;
        }
      });
      // 这里如果没有找到对应的县
      if (countyDate == "") {
        countyDate = that.cityDates.children[0];
      }
      // return 县
      return countyDate.children.map(function(res) {
        return { text: res.label, code: res.code };
      });

      // return 返回数据格式，因为我需要省市区code，所以我return的格式是对象,例:[{text:'北京市',code:'1'},{text:'河南省',code:'2'},...],如果你不需要code直接这样就可以 例['北京市','河南省',.....]
    },
    onConfirmc(val) {
      this.merchant_province = `${val[0].text}/${val[1].text}/${val[2].text}`;
      this.shArea = false;
      this.gather.merchant_province = val[0].text; //省级
      this.gather.merchant_province_code = val[0].code; //省级编号
      this.gather.merchant_city = val[1].text; //市级
      this.gather.merchant_city_code = val[1].code; //市级编号
      this.gather.merchant_county = val[2].text; //所在区
      this.gather.merchant_county_code = val[2].code; //所在区编号
    },
    onChangs(picker, values) {
      picker.setColumnValues(1, this.cityData(this.datx, values[0].text));
      picker.setColumnValues(2, this.counta(this.datx, values[1].text));
    },
    // 修改二级
    cityData(data, province) {
      var that = this;
      data.forEach(function(res) {
        if (res.name == province) {
          that.cityDater = res;
        }
      });
      return that.cityDater.children.map(function(res) {
        return { text: res.name };
      });
    },
    counta(data, county) {
      var that = this;
      var countyDate = "";
      that.cityDater.children.forEach(function(res) {
        if (res.name == county) {
          countyDate = res;
        }
      });
      if (countyDate == "") {
        countyDate = that.cityDater.children[0];
      }
      return countyDate.children.map(function(res) {
        return { text: res.thirdname, code: res.code };
      });
    },
    onConfirmw(val) {
      this.business_name = `${val[2].text}`;
      this.gather.business_name = val[2].text;
      this.gather.business_code = val[2].code;

      this.shAres = false;
    },
    async fupayAreaListse() {
      //请求数据银行 地址 类型
      let res = await request(
        "user/business/merchantApplyStatus?token=" + getUserToken()
      );
      if (res.error == 0 && res.data) {
        if (res.data.status != 0) {
          this.$router.push({
            path: "audit"
          });
        }
      } else {
        Toast(res.error_reason);
      }

      let fupayAreaListst = localStorage.getItem("fupayAreaListst");
      if (!fupayAreaListst) {
        let res = await request(
          "payments/fupay/areaLists?token=" + getUserToken()
        );
        // console.log(res.data, "我是地址");
        if (res.data) {
          this.data = res.data;
          localStorage.setItem("fupayAreaListst", JSON.stringify(this.data));
          this.columnsaqw();
        }
        // fupayAreaLists().then(res => {
        //   console.log(res.data, "我是地址");
        //   if (res.data) {
        //     this.data = res.data;
        //     localStorage.setItem("fupayAreaListst", JSON.stringify(this.data));
        //     this.columnsaqw();
        //   }
        // });
      }
      let industryt = localStorage.getItem("industryt");
      if (!industryt) {
        let res = await request(
          "user/business/industry?token=" + getUserToken()
        );
        // console.log(res, "我是类目");
        if (res.data) {
          this.datx = res.data;
          localStorage.setItem("industryt", JSON.stringify(this.datx));
          this.columnsaqk();
        }
        // industry().then(res => {
        //   console.log(res, "我是类目");
        //   if (res.data) {
        //     this.datx = res.data;
        //     localStorage.setItem("industryt", JSON.stringify(this.datx));
        //     this.columnsaqk();
        //   }
        // });
      }
    },
    async fybankBranchListse() {
      //请求数据银行接口
      this.finished = false;
      let data = {
        keyword: this.search,
        size: "100"
      };
      // console.log(data);
      let res = await request(
        "payments/fupay/bankBranchLists?token=" + getUserToken(),
        data
      );
      // console.log(res, "我是银行");
      if (res.data) {
        // console.log(res.data);
        this.searchlist = res.data;
        this.columnl = Object.values(res.data).map(function(e) {
          return { text: e.back_branch_name, code: e.back_branch_number };
        });
      }
      // fybankBranchLists(data).then(res => {
      //   console.log(res, "我是银行");
      //   if (res.data) {
      //     console.log(res.data);
      //     this.searchlist = res.data;
      //     this.columnl = Object.values(res.data).map(function(e) {
      //       return { text: e.back_branch_name, code: e.back_branch_number };
      //     });
      //   }
      // });
    },
    columnsaqw() {
      //三级联动自定义设置数据格式
      // 默认展示一级的数据
      let fupayAreaListst = localStorage.getItem("fupayAreaListst"); //将不变的数据存放到浏览器存储中以防用户每次请求数据影响使用
      if (fupayAreaListst) {
        //判断如果浏览器存储中存放了就不需要再次请求数据了
        this.data = JSON.parse(localStorage.getItem("fupayAreaListst"));
      }
      this.columns[0].values = Object.values(this.data).map(function(e) {
        return { text: e.label, code: e.code };
      });
      // 默认展示二级的数据
      this.columns[1].values = Object.values(this.data[0].children).map(
        function(e) {
          return { text: e.label, code: e.code };
        }
      );
      // 默认展示三级的数据
      this.columns[2].values = Object.values(
        this.data[0].children[0].children
      ).map(function(e) {
        return { text: e.label, code: e.code };
      });
    },
    columnsaqk() {
      // 默认展示一级的数据
      let industryt = localStorage.getItem("industryt");
      if (industryt) {
        this.datx = JSON.parse(localStorage.getItem("industryt"));
      }
      this.columna[0].values = Object.values(this.datx).map(function(e) {
        return { text: e.name };
      });
      // // 默认展示二级的数据
      this.columna[1].values = Object.values(this.datx[0].children).map(
        function(e) {
          return { text: e.name };
        }
      );
      // // 默认展示三级的数据
      this.columna[2].values = Object.values(
        this.datx[0].children[0].children
      ).map(function(e) {
        return { text: e.thirdname, code: e.code };
      });
    },
    /*--接收子组件中返回的数据--*/
    identityZ(data) {
      //法人身份证正面
      this.fylist.img_idcard_a = data;
    },
    identityY(data) {
      //法人身份证反面
      this.fylist.img_idcard_b = data;
    },
    img_bankcard_a(data) {
      //入账银行卡正面照片
      this.fylist.img_bankcard_a = data;
    },
    img_bankcard_b(data) {
      //入账银行卡反面照片
      this.fylist.img_bankcard_b = data;
    },
    img_private_idcard_a(data) {
      //对私账户身份证正面照片
      this.fylist.img_private_idcard_a = data;
    },
    img_private_idcard_b(data) {
      //对私账户身份证反面照片
      this.fylist.img_private_idcard_b = data;
    },
    img_logo(data) {
      //商户门头照片
      this.fylist.img_logo = data;
    },
    img_indoor(data) {
      //门脸(内设)照片(前台)
      this.fylist.img_indoor = data;
    },
    img_contract(data) {
      //店内环境照片
      this.fylist.img_contract = data;
    },
    img_other(data) {
      //其他证明材料
      this.fylist.img_other = data;
      // console.log(this.fylist.img_other, "其他证明材料");
    },
    img_idcard_holding(data) {
      //本人手持身份证照片
      this.fylist.img_idcard_holding = data;
      // console.log(this.fylist.img_idcard_holding, "本人手持身份证照片");
    },
    img_open_permits(data) {
      //开户许可证照片
      this.fylist.img_open_permits = data;
      // console.log(this.fylist.img_open_permits, "开户许可证照片");
    },
    img_org_code(data) {
      //组织机构代码证照片
      this.fylist.img_org_code = data;
      // console.log(this.fylist.img_org_code, "组织机构代码证照片");
    },
    img_tax_reg(data) {
      //税务登记证照片
      this.fylist.img_tax_reg = data;
      // console.log(this.fylist.img_tax_reg, "税务登记证照片");
    },
    img_unincorporated(data) {
      //入账非法人证明照片
      this.fylist.img_unincorporated = data;
      // console.log(this.fylist.img_unincorporated, "入账非法人证明照片");
    },
    // img_sub_account_promiss(data) {
    //   //	分账承诺函
    //   this.gather.img_sub_account_promiss = data;
    // },
    business(data) {
      //营业执照
      this.fylist.img_license = data;
    },
    onConfirm(date) {
      this.show = false;
      this.fylist.license_expire = this.formatDate(date);
    },
    onConfirma(date) {
      this.showse = false;
      this.fylist.legalIdnumExpire = this.formatDate(date);
    },
    onConfirmas(date) {
      this.showses = false;
      this.fylist.merchant_id_expire = this.formatDates(date);
    },
    // onConfirmasa(date) {
    //   this.showsesq = false;
    //   this.gather.business_name = this.formatDate(date);
    // },
    /*--改变需要的时间数据格式0000-00-00--*/

    formatDate(date) {
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var dates = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return `${year}-${month}-${dates}`;
    },
    newdate() {
      var datetime = new Date();
      var year = datetime.getFullYear();
      var month =
        datetime.getMonth() + 1 < 10
          ? "0" + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1;
      var date =
        datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      this.fylist.license_expire = `${year}-${month}-${date}`;
      this.fylist.legalIdnumExpire = `${year}-${month}-${date}`;
      this.fylist.merchant_id_expire = `${year}${month}${date}`;
      this.fylist2.license_expire = `${year}-${month}-${date}`;
      this.fylist2.legalIdnumExpire = `${year}-${month}-${date}`;
      this.fylist2.merchant_id_expire = `${year}${month}${date}`;
    },
    /*--改变需要的时间数据格式00000000中间不需要任何分隔符--*/

    formatDates(date) {
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var dates = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return `${year}${month}${dates}`;
    },
    /*--填写完数据需要提交时进行判断用户输入的字段是否为空--*/
    async nextstep() {
      if (!this.gather.merchant_name) {
        Toast("商家名称不能为空");
        return;
      }
      if (!this.gather.merchant_alias) {
        Toast("商家简称不能为空");
        return;
      }
      if (!this.gather.merchant_company) {
        Toast("商家注册名称不能为空");
        return;
      }
      if (!this.gather.merchant_province) {
        Toast("地址不能为空");
        return;
      }
      if (!this.gather.merchant_address) {
        Toast("详细地址不能为空");
        return;
      }
      if (!this.gather.merchant_person) {
        Toast("姓名不能为空");
        return;
      }
      if (!this.gather.merchant_phone.trim()) {
        Toast("客户电话不能为空");
        return;
      }
      if (!this.gather.merchant_email.trim()) {
        Toast("客户邮箱不能为空");
        return;
      }
      if (!this.gather.merchant_service_phone.trim()) {
        Toast("客户服务电话不能为空");
        return;
      }
      if (!this.gather.business_name) {
        Toast("行业类目名称不能为空");
        return;
      }
      /*--将用户输入的信息用展开用算符进行展开参数传入后台--*/

      let data = {
        ...this.gather,
        ...this.fylist
      };
      let res = await request("user/mulpay/save?token=" + getUserToken(), data);
      if (res.error == 0) {
        Toast(res.error_reason);
        this.$router.push({
          path: "audit"
        });
      } else if (res.error != 0) {
        Toast(res.error_reason);
      }
    },
    async details() {
      let res = await request("user/mulpay/details?token=" + getUserToken());
      console.log(res, "111=====-");
      if (res.data && res.error == 0) {
        var data = res.data;
        this.merchant_province = `${data.merchant_province}/${data.merchant_city}/${data.merchant_county}`;
        this.business_name = `${data.business_name}`;

        this.gather = {
          merchant_name: data.merchant_name, //商家名称
          merchant_alias: data.merchant_alias, //商家简称
          merchant_company: data.merchant_company, //商家注册名称
          merchant_province: data.merchant_province, //省级
          merchant_province_code: data.merchant_province_code, //省级编号
          merchant_city: data.merchant_city, //市级
          merchant_city_code: data.merchant_city_code, //市级编号
          merchant_county: data.merchant_county, //所在区
          merchant_county_code: data.merchant_county_code, //所在区编号
          merchant_address: data.merchant_address, //详细地址
          merchant_person: data.merchant_person, //姓名
          merchant_phone: data.merchant_phone, //客户电话
          merchant_email: data.merchant_email, //客户邮箱
          merchant_service_phone: data.merchant_service_phone, //客户服务电话
          // ///////////////////////////////////////////////////////
          merchant_business_type: data.merchant_business_type, //客户服务主体类型
          business_name: data.business_name, //行业类目名称
          business_code: data.business_code //行业类目编码
          // img_sub_account_promiss: "" //分账承诺函
        };
     
        this.fylist = {
          account_type:data.account_type , //财户类型
          settlement_type: "1", //结算类型
          license_type: "0", //营业证件类型
          license_no: "", //营业证件号码
          license_expire: "", //营业证件到期日GoodsHouseholdType
          artif_nm: "", //法人姓名
          legalIdnum: "", //法人身份证
          legalIdnumExpire: "", //法人身份证到期
          merchant_id_no: "", //结算人身份证号码
          merchant_id_expire: "", //结算人身份证到期
          account_name: "", //	入账银行开户号
          account_no: "", //入账银行开户卡号
          account_phone: "", //入账银行预留手机号
          bank_name: "", //入账银行卡开户支行
          bank_no: "", //入账银行卡开户支行联行号
          settle_type: "1", //清算类型 1：自动结算，2：手动结算
          img_license: "", //营业执照
          img_idcard_a: "", //法人身份证正面
          img_idcard_b: "", //法人身份证反面
          img_private_idcard_a: "", //对私账户身份证正面照片
          img_private_idcard_b: "", //对私账户身份证反面照片
          img_bankcard_a: "", //入账银行卡正面照片
          img_bankcard_b: "", //入账银行卡反面照片
          img_logo: "", //商户门头照片
          img_indoor: "", //门脸(内设)照片(前台)
          img_contract: "", //店内环境照片
          img_other: "", //其他证明材料
          img_idcard_holding: "", //本人手持身份证照片
          img_open_permits: "", //开户许可证照片
          img_org_code: "", //组织机构代码证照片
          img_tax_reg: "", //税务登记证照片
          img_unincorporated: "" //入账非法人证明照片
        };
        console.log(this.fylist);
      }
    }
  },
  // mounted() { this.details();},
  created() {
    
    /*--刚进入页面进行判断浏览器存储中的数据--*/
    let fupayAreaListst = localStorage.getItem("fupayAreaListst");
    if (fupayAreaListst) {
      this.columnsaqw();
    }
    let industryt = localStorage.getItem("industryt");
    if (industryt) {
      this.columnsaqk();
    }
    /*--进入页面首先执行数据请求--*/
    this.fupayAreaListse();
    this.newdate();
    // this.details();
    this.fybankBranchListse();
  },

  beforeMount() {
  //  this.details();
  }
};
</script>
<style lang="scss" scoped>
.merchant {
  width: 100%;
  background: rgba(246, 247, 249, 1);
  .home-perspmal-van-cell {
    overflow: hidden;
    background-color: #fff;
    padding: 1.25rem 0.6875rem 1.25rem 0.6875rem;

    .home-perspmal-van-cell__title {
      float: left;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-perspmal-van-cell__value {
      float: right;
      .van-cell::after {
        border-bottom: 0px;
      }
      .van-cell {
        padding: 0;
      }
      input {
        border: 0;
      }
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(198, 198, 198, 1);
      }
    }
    .home-perspmal-van-cell__values {
      width: 100%;
      padding-top: 1.34375rem;
      display: flex;
      div {
        width: 100%;
        div {
          margin: 0;
          flex: 1;
        }
        div:first-child {
          justify-content: flex-start;
        }
        div:nth-child(2) {
          justify-content: center;
        }
        div:last-child {
          justify-content: flex-end;
        }
      }
    }
    .home-perspmal-van-cell__val {
      display: flex;
    }
  }

  /deep/.home-perspmal-van-cell__value span[data-v-3dce2c05] {
    font-size: 0.81875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home-cell__value-buttom {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0.75rem;
    overflow: hidden;
  }
  /deep/.van-icon-success::before {
    content: "";
  }
  /deep/.van-checkbox__icon--checked .van-icon,
  /deep/.van-radio__icon--checked .van-icon {
    color: #fff;
    background-color: #fff;
    border: 0.4rem solid #1980fa;
  }
  /deep/.van-cell--required::before {
    content: "";
  }
  /deep/.van-field__control {
    text-align: right;
  }

  // 第二页的
}
.home {
  width: 100%;
  background: rgba(246, 247, 249, 1);
  .home-perspmal-van-cell {
    overflow: hidden;
    background-color: #fff;
    padding: 1.25rem 0.6875rem 1.25rem 0.6875rem;

    .home-perspmal-van-cell__title {
      float: left;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-perspmal-van-cell__value {
      float: right;
      .van-cell::after {
        border-bottom: 0px;
      }
      .van-cell {
        padding: 0;
      }
      input {
        border: 0;
      }
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(198, 198, 198, 1);
      }
    }
    .home-perspmal-van-cell__values {
      width: 100%;
      padding-top: 1.34375rem;
      display: flex;
      div {
        width: 100%;
        div {
          margin: 0;
          flex: 1;
        }
        div:first-child {
          justify-content: flex-start;
        }
        div:nth-child(2) {
          justify-content: center;
        }
        div:last-child {
          justify-content: flex-end;
        }
      }
    }
    .home-perspmal-van-cell__val {
      display: flex;
    }
  }

  /deep/.home-perspmal-van-cell__value span[data-v-3dce2c05] {
    font-size: 0.81875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.van-cell__title {
    font-size: 1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
  .uploader-business {
    padding: 1.25rem 0.6875rem;
    /deep/.van-uploader__upload,
    /deep/.van-uploader__preview-image {
      width: 4.65625rem;
      height: 8.28125rem;
      background: rgba(242, 242, 242, 1);
    }
    /deep/.van-field__control--custom {
      align-items: flex-end;
      justify-content: flex-end;
    }
  }
  .uploader-identity {
    padding: 1.25rem 0.6875rem;
    display: block;
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/ .van-uploader__upload {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/.van-field__control {
      justify-content: center;
      align-items: center;
      .van-uploader__preview-image {
        width: 9.375rem;
        height: 6.25rem;
      }
    }
    /deep/.van-uploader:first-child {
      margin-right: 1.25rem;
      // margin-right: 2.5rem;
      .van-uploader__upload {
        background: url("../../assets/image/Merch.jpg");
        background-size: 100% 100%;
      }
    }
    /deep/.van-uploader:last-child {
      .van-uploader__upload {
        background: url("../../assets/image/Merchs.jpg");
        background-size: 100% 100%;
      }
    }
  }
  .uploader-bankCard {
    padding: 1.25rem 0.6875rem;
    display: block;
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/ .van-uploader__upload {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/.van-field__control {
      justify-content: center;
      align-items: center;
      .van-uploader__preview-image {
        width: 9.375rem;
        height: 6.25rem;
      }
    }
    /deep/.van-uploader:first-child {
      margin-right: 1.25rem;
      // margin-right: 2.5rem;
    }
  }

  .home-perspmal-MerchantEntrancePhoto {
    display: block;
    /deep/.van-uploader__preview {
      margin: 0 0.3rem 0.25rem 0;
    }
    /deep/.van-uploader__preview-image {
      width: 4.7rem;
      height: 4.7rem;
    }
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader__upload {
      width: 4.7rem;
      height: 4.7rem;
    }
  }
  /deep/.van-icon-success::before {
    content: "";
  }
  /deep/.van-checkbox__icon--checked .van-icon,
  /deep/.van-radio__icon--checked .van-icon {
    color: #fff;
    background-color: #fff;
    border: 0.4rem solid #1980fa;
  }
  /deep/.van-cell--required::before {
    content: " ";
  }
  /deep/.van-field__control {
    text-align: right;
  }
  .home-cell__value-buttom {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0.75rem;
    overflow: hidden;
  }
  .home-pmal-Photo {
    /deep/.van-field__label {
      flex: 1.5;
    }
    /deep/.van-field__control--custom {
      justify-content: flex-end;
    }
  }
}
.search-rights {
  width: 100%;
  overflow-y: scroll;
  /deep/.van-field__body {
    /deep/input {
      text-align: center;
    }
  }

  .back_branch_number {
    text-align: center;
    line-height: 2.5rem;
    font-size: 0.8rem;
  }
}
</style>
